import script from "./OrderCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCreate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__